import { bianka, BIANKA_ACTIVITY_TYPES } from '@fiverr-private/obs';

export const reportIdentificationClose = (elementName: string) => {
    bianka.reportActivity({
        type: BIANKA_ACTIVITY_TYPES.CLICK,
        event: {
            type: 'identification_close',
            element: {
                name: elementName,
            },
        },
    });
};
